<template>
    <ul :class="layoutClass">
        <li>
            <el-checkbox v-model="item.checked" @change="$emit('singleElection')"></el-checkbox>
        </li>
        <li class="main">
            <goods-info :item="item"></goods-info>
            <div class="cart-info"></div>
        </li>
        <li class="mini-li" v-if="layoutClass === 'mini'">
            <cartAndOrder_price :info="item" :showNum="true"></cartAndOrder_price>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
        <li>
            <cartAndOrder_price :info="item" :showCouponPrice="true"></cartAndOrder_price>
        </li>
        <li>
            <el-input-number v-model="item.num" :step="item.min_buy || 1" size="mini" :min="item.min_buy || 1"
                             :max="item.stock" @change="cartNumChange"></el-input-number>
        </li>
        <li>
            <template v-if="couponSubtotalDisplay.show">
                <div class="coupon-subtotal">
                    <div class="coupon-subtotal-main">
                        <strong class="subtotal ns-text-color">￥{{ couponSubtotalDisplay.couponSubtotal }}</strong>
                        <img :src="$util.img('/upload/uniapp/discount_after.png')" alt="折后约" />
                    </div>
                    <span class="coupon-subtotal-origin">￥{{ calculationOfPrice }}</span>
                </div>
            </template>
            <strong v-else class="subtotal ns-text-color">￥{{ calculationOfPrice }}</strong>
        </li>
        <li>
            <el-button type="text" @click="$emit('deleteCart')">删除</el-button>
        </li>
    </ul>
</template>
<script>
    import CartItemMixin from "@/views/goods/cart/common/cart-item-mixin"
    import cartAndOrder_price from "@/components/cartAndOrder/cartAndOrder_price.vue"
    export default {
        name: "default-cart-item",
        mixins: [CartItemMixin],
        components: {
            cartAndOrder_price
        },
        computed: {
            calculationOfPrice() {
                let subtotal = Number(this.item.discount_price * this.item.num).toFixed(2)
                // 先判断是否超出限购数量 goods_limit
                this.item.subtotal = subtotal
                return subtotal
            },
            couponSubtotalDisplay() {
                const couponPrice = Number(this.item.coupon_price)
                const num = Number(this.item.num)
                const originSubtotal = Number(this.calculationOfPrice)
                const couponSubtotal = couponPrice * num

                if (!couponPrice || couponPrice <= 0 || !num || couponSubtotal <= 0 || couponSubtotal === originSubtotal) {
                    return {
                        show: false,
                        couponSubtotal: ""
                    }
                }

                return {
                    show: true,
                    couponSubtotal: couponSubtotal.toFixed(2)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../common/list.scss';
    .coupon-subtotal{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: initial;
        gap: 4px;
    }
    .coupon-subtotal-main{
        display: flex;
        align-items: center;
        gap: 4px;
        img{
            width: 53px;
            height: 17px;
        }
    }
    .coupon-subtotal-origin{
        color: #999;
        font-size: 12px;
        font-weight: bold;
    }
</style>
